import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostCardNewsLoading, EGetPostCardNewsActionType } from './types';

export const getPostCardNewsLoading: () => TGetPostCardNewsLoading =
  actionGenerator<EGetPostCardNewsActionType.Loading>(EGetPostCardNewsActionType.Loading);
